import { Link } from 'react-router-dom'

import {
  DropdownMenu,
  EllipsisVerticalIcon,
  IconButton,
  Grid3x3Icon,
  SettingsIcon,
} from '@buffer-mono/popcorn'

import type { JSX } from 'react'

interface ChannelSettingsMenuProps {
  channelId: string
  service: string
  channelType: string
  className?: string
}

/**
 * Channel settings button/menu shown in VR mobile headers.
 *
 * For Instagram business/creator channels: renders a dropdown with
 * Settings, Instagram Preview, and Shop Grid links.
 * For all other channels: renders a single settings icon button.
 */
export function ChannelSettingsMenu({
  channelId,
  service,
  channelType,
  className,
}: ChannelSettingsMenuProps): JSX.Element {
  if (service === 'instagram' && channelType !== 'profile') {
    return (
      <DropdownMenu>
        <DropdownMenu.Trigger>
          <IconButton
            variant="tertiary"
            label="Channel menu"
            size="large"
            data-tour-id="channel-settings"
            className={className}
          >
            <EllipsisVerticalIcon />
          </IconButton>
        </DropdownMenu.Trigger>
        <DropdownMenu.Content>
          <DropdownMenu.Item asChild>
            <Link to={`/channels/${channelId}/settings`}>
              <SettingsIcon /> Channel Settings
            </Link>
          </DropdownMenu.Item>
          <DropdownMenu.Item asChild>
            <Link
              to={`/channels/${channelId}/shop-grid?view=instagram-preview`}
            >
              <Grid3x3Icon /> Instagram Preview
            </Link>
          </DropdownMenu.Item>
          <DropdownMenu.Item asChild>
            <Link to={`/channels/${channelId}/shop-grid?view=shop-grid`}>
              <Grid3x3Icon /> Shop Grid
            </Link>
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu>
    )
  }

  return (
    <IconButton
      variant="tertiary"
      label="Channel settings"
      tooltip="Channel Settings"
      size="large"
      as={Link}
      to={`/channels/${channelId}/settings`}
      data-tour-id="channel-settings"
      className={className}
    >
      <SettingsIcon />
    </IconButton>
  )
}
